<template>
  <div class="tags-modal">
    <div class="tags-modal__activities">
      <TagsModalActivitiesNew v-if="activeProject === 'site'" :activitiesId="categoryId" @confirmDeleteTag="removeTag" @editTag="goToEdit"/>
      <TagsModalActivitiesEducation v-if="activeProject === 'education'"/>
    </div>
    </div>
    <ChangeTagsModal
      v-if="ChangeTagsModalVisible"
      :activitiesId="categoryId"
    />
    <div class="buttons">
    <BaseBtnNew
      name="Добавить тег"
      @clickBtn="saveTags"
    >
    <addTagIcon/>
    </BaseBtnNew>
    <!-- <BaseBtn
      blue
      text="Отменить"
      @clickBtn="cancelTags"
    /> -->
  </div>
  <ConfirmDelete
    v-if="acceptDelete"
    @cancel="closeModal"
    @remove="removeTag"
  />
</template>

<script>
import { useStore } from 'vuex'
import { onBeforeMount, computed, ref } from 'vue'
import TagsModalActivitiesNew from '@/components/elements/TagsModalActivitiesNew.vue'
import TagsModalActivitiesEducation from '@/components/elements/TagsModalActivitiesEducation.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import ChangeTagsModal from '@/components/modals/ChangeTagsModal.vue'
import ConfirmDelete from '@/components/modals/ConfirmDelete'
import addTagIcon from '@/components/icons/addTagIcon'

export default {
  name: 'TagsModalNew',
  components: {
    TagsModalActivitiesNew,
    TagsModalActivitiesEducation,
    BaseBtnNew,
    ChangeTagsModal,
    ConfirmDelete,
    addTagIcon
  },
  props: {
    categoryId: {
      type: Number,
      default: null
    }
  },
  setup (props) {
    const store = useStore()

    const activeProject = ref(null)

    onBeforeMount(() => {
      activeProject.value = localStorage.activeProject
    })

    const tagsObj = computed(() => {
      return store.getters.getChangeTagsObj
    })

    const ChangeTagsModalVisible = computed(() => {
      return store.getters.getShowChangeTagsEditor
    })

    const acceptDelete = ref(false)

    const goToEdit = (item) => {
      store.commit('SetChangeTagsObj', item)
      store.commit('SetShowChangeTagsEditor', true)
    }

    const searchTags = (e) => {
      if (localStorage.activeProject === 'site') {
        store.commit('SetTagsDataFilter', e.target.value.trim())
      } else if (localStorage.activeProject === 'education') {
        store.commit('SetTagsDataEducationFilter', e.target.value.trim())
      }
    }

    const deleteTag = () => {
      acceptDelete.value = true
    }

    const closeModal = () => {
      acceptDelete.value = false
    }

    const removeTag = (data) => {
      if (localStorage.activeProject === 'site') {
        const obj = {
          id: data.Id,
          category: props.categoryId
        }
        store.dispatch('setDeleteTag', obj)
      } else if (localStorage.activeProject === 'education') {
        const obj = {
          id: tagsObj.value.Id
        }
        store.dispatch('setDeleteTagEducation', obj)
      }
      acceptDelete.value = false
    }

    const saveTags = () => {
      // разделение логики на два проекта с привязкой к значению из localStorage
      if (localStorage.activeProject === 'site') {
        if (props.categoryId === 3) {
          store.dispatch('setUpdateInnerTags')
        } else if (props.categoryId === 2) {
          store.dispatch('setUpdateInnerTagsNews')
        } else if (props.categoryId === 4) {
          store.dispatch('setUpdateInnerTagsServices')
        }
      } else if (localStorage.activeProject === 'education') {
        store.dispatch('setUpdateInnerTagsEducation')
      }
      store.commit('SetShowTagsEditor', false)
    }

    const cancelTags = () => {
      // разделение логики на два проекта с привязкой к значению из localStorage
      if (localStorage.activeProject === 'site') {
        if (props.categoryId === 3) {
          store.dispatch('setClearCacheInnerTag')
        } else if (props.categoryId === 2) {
          store.dispatch('setClearCacheInnerTagNews')
        } else if (props.categoryId === 4) {
          store.dispatch('setClearCacheInnerTagServices')
        }
      } else if (localStorage.activeProject === 'education') {
        store.dispatch('setClearCacheInnerTagEducation')
      }
      store.commit('SetShowTagsEditor', false)
    }

    return {
      activeProject,
      goToEdit,
      ChangeTagsModalVisible,
      searchTags,
      tagsObj,
      deleteTag,
      saveTags,
      cancelTags,
      acceptDelete,
      closeModal,
      removeTag
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-modal {
  width: 1224px;

  &__header {
    display: flex;
    justify-content: flex-end;
  }

  .header-modal {
    &__buttons {
      display: flex;
      gap: 24px;
      padding-right: 64px;
    }
    &__search {
      width: 310px;
      height: 40px;
    }
  }

  &__activities {
    overflow-y: auto;
    height: 568px;
  }
}

.buttons {
  position: absolute;
  right: 0px;
  left: 0px;
  bottom: 0px;
  padding: 24px;
  border-top: 2px solid #D6D6D6;
  background-color: #F5F5F5;
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  width: 100%;
  :deep(.base-button) {
    width: 200px;
  }
}
</style>
